/**
 * useThemeStore — Light/dark/system theme toggle.
 *
 * Storage: 'theme-storage' (Zustand persist middleware, NOT alphafocus_ prefix)
 * Methods: setTheme, toggleTheme
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useThemeStore = create(
    persist(
        (set) => ({
            theme: 'system', // 'light', 'dark', 'system'
            setTheme: (theme) => set({ theme }),
            toggleTheme: () => set((state) => {
                const current = state.theme;
                if (current === 'system') {
                    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
                    return { theme: isDark ? 'light' : 'dark' };
                }
                return { theme: current === 'dark' ? 'light' : 'dark' };
            }),
        }),
        {
            name: 'theme-storage',
        }
    )
);

export default useThemeStore;
